
define('views/template/leftColumn/index',[
	"ssi!fragment/leftnav/index",
	"ssi!fragment/leftnav/noSearchBox/index"
], function(leftNav, leftNavNoSearchBox) {
	
	var LeftColumnView = Backbone.View.extend({

		initialize: function() {
			
//			if(!this.$el.html())
				this.render();
			// else {
			// 	if(this.options.leftColumnView) {
			// 		new this.options.leftColumnView(
			// 			_.extend({}, {el: this.$(".custom-view").get(0)}, this.options.viewOptions)
			// 		);
			// 	}
			// }

		},

		render: function() {

			if(this.options.leftColumnView) {
				this.view = new this.options.leftColumnView(
					_.extend({}, {className: "custom-view", contentEl: this.options.contentEl}, this.options.viewOptions)
				);
				this.$el.html('').append(this.view.el);
			} else {
				if(!this.$el.html())
					this.$el.html(_.template((this.options.noSearchBox ? leftNavNoSearchBox : leftNav)));
			}

			if(this.options.noSearchBox) {
				this.$el.addClass("noSearchBox")
			}


			if(this.options.extendLeftColumn)
				$("html").addClass("extendLeftColumn");

		}


	});

	return LeftColumnView;

});